import React from 'react';
import { GraduationCap } from 'lucide-react';
import SoutenanceCard from './SoutenanceCard';

const SoutenanceList = ({ 
  soutenances, 
  loading, 
  searchTerm, 
  onEdit, 
  onDelete, 
  onViewDetails, 
  onAddNew,
  filters 
}) => {
  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="bg-gray-200 h-32 rounded-lg animate-pulse"></div>
        ))}
      </div>
    );
  }

  // Make sure soutenances is always an array
  const soutenancesArray = Array.isArray(soutenances) ? soutenances : [];
  
  if (soutenancesArray.length === 0) {
    const hasFilters = searchTerm || Object.values(filters || {}).some(f => f);
    
    return (
      <div className="text-center py-12">
        <GraduationCap className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">
          {hasFilters ? 'Aucune soutenance trouvée' : 'Aucune soutenance'}
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          {hasFilters ? 
            'Essayez de modifier vos critères de recherche.' : 
            'Commencez par créer une nouvelle soutenance.'
          }
        </p>
        {!hasFilters && (
          <div className="mt-6">
            <button
              onClick={onAddNew}
              className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
            >
              Créer une soutenance
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {soutenancesArray.map((soutenance) => (
        <SoutenanceCard
          key={soutenance.id}
          soutenance={soutenance}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
};

export default SoutenanceList; 